<div class="app-header">
    <div class="app-header-wrapper">
        <div class="menu-icon-wrapper" #sideNavOnHeader>
            <div class="menu-icon-block" (click)="onOpenSideBar()">
                <div>
                    <img src="/assets/icons/Group 2436.svg" alt="icon">
                </div>
                <div>
                    <img src="/assets/icons/shape.svg" style="margin-bottom: 2px" alt="shape icon">
                </div>
            </div>
            <div class="my-co-creator-logo">
                <img src="assets/icons/Logo.svg" alt="logo">
            </div>
        </div>

        <div class="search-block">
            <input type="text" [(ngModel)]="searchControl" placeholder="Search by Prompt Title"
                (keydown.enter)="seachresult(searchControl, $event, false)" (focusout)="focusOut()"
                (input)="onInputChange($event);seachresult(searchControl, $event, false)" style="border: none; width: 100%;" />
            <div (click)="onInputChange($event);seachresult(searchControl, $event, false)">
                <img src="/assets/icons/Group 57082.svg" alt="icon"/>
            </div>
            <ul *ngIf="filteredSuggestions.length > 0" class="suggestions-list">

                <li (click)="seachresult(suggestion.title, $event, true, suggestion)" *ngFor="let suggestion of filteredSuggestions"
                    style="border-bottom: 1px solid #E1E1EA;">
                    <span [innerHTML]="highlightText(suggestion.title, searchControl)"></span>
                </li>

            </ul>
        </div>
        <div class="log-out" >
            <div class="merk-logo">
                <img src="/assets/icons/Merck Logo.svg" alt="merck logo"/>
            </div>
            <div class="user-1" (click)="togglePanel()" (mouseover)="panelVisible = true"  >
                <img src="/assets/icons/User.svg" alt="user icon"/>

                <div class="logout-div" (mouseover)="panelVisible = true"   *ngIf="panelVisible" (click)="$event.stopPropagation()">
                    <div style="display: flex; justify-content: space-between; align-items: center; gap: 16px;">
                        <div style="border-radius: 20px;
                     background: var(--Core-Colors-Cyan_Accent, #2DBECD);
                     padding: 5px;">
                            <img src="/assets/Userlogout.svg" alt="logout icon"/>
                        </div>

                        <div>
                            <label style="color: var(--Rich-Black---default, #1B1B25);
                            font-family: Lato, sans-serif;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 18px; /* 128.571% */" for="">{{usename}}</label><br>
                            <label style="color: #7D7C87;
                            font-family: Lato, sans-serif;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 18px;">{{user_role.charAt(0)?.toUpperCase() + user_role?.slice(1)}}</label>
                        </div>
                    </div>
                    <hr style="width: 274px;
                    height: 1px;
                    background: #E1E1EA;
                    /* outline: white; */
                    border-top: none;
                    border-left: none;">
                    <div style="display: flex;
                    height: 32px;
                    padding: var(--space-050, 4px) 10px var(--space-050, 4px) var(--space-100, 8px);
                    align-items: center;
                    gap: var(--space-100, 8px);">
                        <div style="margin-top: 5px;"><img src="/assets/logout.svg" alt="logout icon"/></div>
                        <div><label style="color: var(--Core-Colors-Purple_Default, #503291);
                            font-feature-settings: 'liga' off, 'clig' off;
                            font-family: Lato, sans-serif;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 700;
                            cursor: pointer;
                            line-height: 120%; /* 16.8px */" (click)="logout()"> Logout</label></div>




                    </div>

                </div>

            </div>



        </div>
    </div>

</div>